import React from "react";
import { useSettingsSearch } from "./SettingsSearchContext";
import { countMatchingSections } from "../data/settingsSearchIndex";

export default function SettingsSearchBar() {
  const { query, setQuery, normalizedQuery } = useSettingsSearch();
  const matchCount = countMatchingSections(normalizedQuery);

  return (
    <div className="settings-search-bar">
      <label className="settings-search-label" htmlFor="settings-search-input">
        Search settings
      </label>
      <div className="settings-search-row">
        <input
          id="settings-search-input"
          type="search"
          className="settings-search-input"
          placeholder="e.g. welcome, mod logs, tickets, boost…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoComplete="off"
          spellCheck={false}
        />
        {query ? (
          <button
            type="button"
            className="settings-search-clear"
            onClick={() => setQuery("")}
          >
            Clear
          </button>
        ) : null}
      </div>
      {normalizedQuery ? (
        <p className="settings-search-hint">
          {matchCount === 0
            ? "No matching sections — try different words."
            : `Showing ${matchCount} matching section${matchCount === 1 ? "" : "s"}. Matching cards open automatically.`}
        </p>
      ) : (
        <p className="settings-search-hint">
          Filter settings cards by name or topic. Use multiple words to narrow
          results.
        </p>
      )}
    </div>
  );
}
